import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const HEX = /^#[0-9a-fA-F]{6}$/;

/** Seletor de cor nativo + campo hexadecimal sincronizados. */
export function ColorField({ id, label, value, onChange, error }: { id: string; label: string; value: string; onChange: (v: string) => void; error?: string }) {
  return (
    <div className="grid gap-1.5">
      <Label htmlFor={id}>{label}</Label>
      <div className="flex items-center gap-2">
        <input
          type="color"
          aria-label={`${label} (seletor)`}
          value={HEX.test(value) ? value : '#000000'}
          onChange={(e) => onChange(e.target.value)}
          className="h-9 w-11 shrink-0 cursor-pointer rounded-md border border-input bg-transparent p-1"
        />
        <Input id={id} value={value} onChange={(e) => onChange(e.target.value)} maxLength={7} placeholder="#1F4A3D" className="tabular max-w-32 font-mono" aria-invalid={!!error} />
      </div>
      {error && (
        <p role="alert" className="text-xs text-destructive">
          {error}
        </p>
      )}
    </div>
  );
}
